export default __webpack_public_path__ + "static/complete-mtg-cube-power-level-196e68bc0bf6b1c3849942e187751045.png";